import { View, Text } from "react-native";
import { IconButton } from "react-native-paper";
import { formatToUtc } from "../../../utils/dateUtils";
import { useNavigation } from "@react-navigation/native";
import { PdrHistory } from "../../../screens/fragments";

const PdrItem = ({ pdr, isLast }: { pdr: PdrHistory; isLast: boolean }) => {
  const navigation = useNavigation();
  const { category, creditsAccepted, submittedAt, id, description1, creditType } = pdr;
  return (
    <View className={`flex-col border-b border-sky-light py-3 pl-6 web:pl-4 ${isLast ? "border-b-0" : ""}`}>
      <View className="flex-row justify-between items-center">
        <View className="flex-1 pr-2">
          <Text className="text-regular-tight font-400 text-ink-darkest" numberOfLines={2}>
            {category || "N/A"}
          </Text>
          <Text className="text-small font-400 text-ink mt-1" numberOfLines={1}>
            {description1}
          </Text>
        </View>
        <Text className="text-small-tight font-500 text-ink-darkest">Credits {creditsAccepted}</Text>
        <IconButton
          icon="chevron-right"
          size={20}
          style={{ margin: 0 }}
          onPress={() => navigation.navigate("PdrDetails", { id })}
        />
      </View>
      <Text className="text-tiny-tight font-400 text-ink mt-2.5">
        {formatToUtc(submittedAt)} | {creditType}
      </Text>
    </View>
  );
};

export default PdrItem;
